import { get } from 'lodash';
import ReactGA from 'react-ga4';

import { GA_CATEGORY, GA_UTM_CAMPAIGN, GA_UTM_MEDIUM, GA_UTM_SOURCE } from 'configs/constant';
import configs from 'configs/envConfig';

export const GA_EVENT_TYPE = {
    SHARE_FRIENDS: 'share_friends',
    DRAW_PRIZE: 'draw_prize',
    CLICK_MAP_LEVEL: 'click_map_level',
    FINISH_LEVEL_1: 'finish_level_1',
    FINISH_LEVEL_2: 'finish_level_2',
    FINISH_LEVEL_3: 'finish_level_3',
    HOME_TO_DRAW: 'home_to_draw',
    HOME_TO_MAP: 'home_to_map',
    MAP_TO_DRAW: 'map_to_draw',
    OPEN_RULE_MODAL: 'open_rule_modal',
    DRAW_UNFINISH: 'draw_unfinish',
    DRAW_WIN_LOTTERY: 'draw_win_lottery',
    SHARE_FRIEND_RULE_MODAL: 'share_friend_rule_modal'
};

const SHOP_ID = configs.SHOP_ID;
export const sendGAEvent = (lineId, action, others = {}) => {
    console.log('ga', lineId, action, others);
    if (!lineId || !action) return;

    let label = `shop/${SHOP_ID}/customer/${lineId}${get(others, 'label', '')}`;
    const campaign = localStorage.getItem(GA_UTM_CAMPAIGN);
    const source = localStorage.getItem(GA_UTM_SOURCE);
    const medium = localStorage.getItem(GA_UTM_MEDIUM);
    if (campaign) label += `/campaign/${campaign}`;
    if (source) label += `/source/${source}`;
    if (medium) label += `/campaign/${medium}`;
    const event = {
        userId: `shop/${SHOP_ID}/user/${lineId}`,
        referrer: `https://linebot/shop/${SHOP_ID}/user/${lineId}`,
        title: action,
        category: `${GA_CATEGORY}/${SHOP_ID}`,
        action,
        label,
        value: 1,
        ...others
    };
    ReactGA.event({ ...event, SHOP_ID, lineId });
};

export const setGAInLocalstorage = ({ ga_utm_source, ga_utm_medium, ga_utm_campaign }) => {
    console.log('ga_utm_source:' + ga_utm_source, 'ga_utm_medium:' + ga_utm_medium, 'ga_utm_campaign:' + ga_utm_campaign);
    localStorage.setItem(GA_UTM_SOURCE, ga_utm_source);
    localStorage.setItem(GA_UTM_MEDIUM, ga_utm_medium);
    localStorage.setItem(GA_UTM_CAMPAIGN, ga_utm_campaign);
};

export const sendGaView = (lineId, ga) => {
    console.log('ga pageview:', lineId, ga);
    if (!lineId || !ga) return;
    const page = `/shop/${SHOP_ID}/user/${lineId}/action/${ga}`;
    const pageviewEvent = {
        hitType: 'pageview',
        page,
        userId: `shop/${SHOP_ID}/user/${lineId}`,
        referrer: `https://linebot/shop/${SHOP_ID}/user/${lineId}`,
        location: window.location.href || '',
        title: ga
    };
    console.log('pageview', pageviewEvent);
    ReactGA.send(pageviewEvent);
};
